let baseUrl = window.BASE_URL;

export default {
  baseUrl: baseUrl,
  LOGIN: baseUrl + 'api/account/login',
  GetPurchaseOrder: baseUrl + 'api/PurchaseOrder',
  Getstates: baseUrl + 'api/admin/getstates',
  Export: baseUrl + 'api/PurchaseOrder/Export',
  GetPurchaseOrderDetail: baseUrl + 'api/PurchaseOrder/GetPurchaseOrderDetail',
  UpdatePurchaseOrderDetail: baseUrl + 'api/PurchaseOrder/UpdatePurchaseOrderDetail',
  GetClaims: baseUrl + 'api/Claim',
  GetClaimDetail: baseUrl + 'api/Claim/GetClaimDetail',
  POStatusReport: baseUrl + 'api/PurchaseOrder/PurchaseOrderStatusReport',
  PrintPO: baseUrl + 'api/PurchaseOrder/PrintPO',
  ClaimExport: baseUrl + 'api/Claim/Export',
  PrintClaim: baseUrl + 'api/Claim/PrintClaim',
  ClaimStatusReport: baseUrl + 'api/Claim/ClaimStatusReport'
}